import { useRef, useEffect } from 'react'
import anime from 'animejs'
import { Box } from '@chakra-ui/react'

import { ReactComponent as Image } from '@/svg/services/documents-rafiki.svg'

interface Props {
  animate?: boolean
}

function PrivaciesImage({ animate = true }: Props): React.ReactElement {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && animate) {
      const containerClassName = containerRef.current.className
        .split(' ')
        .join('.')

      const animInstances: anime.AnimeInstance[] = []
      const animateConfig = {
        easing: 'easeInOutSine',
        direction: 'alternate',
        loop: true,
        duration: 1500,
        endDelay: 1500,
      }

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #file-1`,
          translateX: ['10%', '0%'],
          translateY: ['28%', '0%'],
          scale: ['0.8', '1'],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #file-2`,
          translateX: ['20%', '0%'],
          translateY: ['60%', '0%'],
          scale: ['0.8', '1'],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #file-3`,
          translateX: ['20%', '0%'],
          translateY: ['28  %', '0%'],
          scale: ['0.8', '1'],
        }),
      )

      animInstances.push(
        anime({
          ...animateConfig,
          targets: `.${containerClassName} #mouth`,
          transform: [
            'matrix(0.866669,0.498883,-0.498883,0.866669,107.925,-181.605)',
            'matrix(1, 0, 0, 1, 0, 0)',
          ],
        }),
      )

      return () =>
        animInstances.forEach((instance: anime.AnimeInstance) =>
          instance.pause(),
        )
    }

    // eslint-disable-next-line @typescript-eslint/no-empty-function
    return () => {}
  }, [containerRef.current, animate])

  return (
    <Box ref={containerRef}>
      <Image />
    </Box>
  )
}
export default PrivaciesImage
